<template>
  <div class="ddtakl">
    {{res}}
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
import { ddTalkLogin } from '@/api/api/user.js'
import Cookie from 'js-cookie'
export default {
  data() {
    return {
      res:''
    }
  },
  created() {
    this.login()
  },
  methods: {
    login() {
      const _this = this
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.runtime.permission.requestAuthCode({
          corpId: 'dingcc6b687668380fd7',
          onSuccess: function(result) {
            // {
            //     code: 'hYLK98jkf0m' //string authCode
            // }
            ddTalkLogin(result.code).then(res => {
              _this.res = res
              if (res.data.errorCode === 0) {
                Cookie.set('token', res.data.data.token, { expires: 0.05 })
                _this.$store.commit('SET_TOKEN', res.data.data.token)
                _this.$router.replace({path:'/home/task'})
              } else {
                _this.$router.replace('/login')
              }
            }).catch(err => {
              console.log(err)
            })
          },
          onFail: function(err) {
            alert('wrong', err)
          }
        })
      })
    }
  }
}
</script>

<style>

</style>